// CancelModal.js
import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from '@material-ui/core';
import CloseIcon from "@material-ui/icons/Close";
const CancelModal = ({ open, handleClose, handleOk, title, description, positiveText = 'Ok' }: any) => {

  return (
    <Dialog open={open} onClose={handleClose}>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <DialogTitle>{title}</DialogTitle>
        <div style={{ marginRight: 10, cursor: "pointer" }} onClick={handleClose}>
          <CloseIcon />
        </div>
      </div>

      <DialogContent>
        <Typography variant="body1">{description}</Typography>
      </DialogContent>
      <DialogActions>

        <Button onClick={handleOk} color="primary">
          {positiveText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelModal;



// WEBPACK FOOTER //
// ./src/components/CancelModal/index.tsx